<template>
  <b-table
    v-if="users"
    id="items"
    show-empty
    hover
    class="users-table"
    head-variant="light"
    stacked="lg"
    :items="users"
    :fields="fields"
    :sort-direction="sortDirection"
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
  >
    <template #thead-top="data">
      <b-tr v-bind:key="data.columns">
        <b-th variant="dark" colspan="8">
          <b-row>
            <b-col class="users-table__header">
              <h5 class="users-table__header__tittle">
                <strong>Total Quotes Unassigned:</strong>
                {{ totalUnassigned }}
              </h5>
              <div class="users-table__header__content">
                <b-form-input
                  v-model="generalNumberOfQuotes"
                  v-if="activeName !== 'second'"
                  placeholder="Quotes"
                  type="number"
                  size="sm"
                  class="users-table__header__content--input"
                  autocomplete="off"
                  min="0"
                ></b-form-input>
                <b-overlay
                  :show="distributing"
                  rounded
                  opacity="0.6"
                  spinner-small
                  class="d-inline-block"
                >
                  <b-button
                    @click="distributeQuotes"
                    :disabled="distributing"
                    v-if="activeName !== 'second'"
                    class="users-table__header__content--option"
                    size="sm"
                    >Distribute</b-button
                  >
                </b-overlay>
                <b-overlay
                  :show="clearingAll"
                  rounded
                  opacity="0.6"
                  spinner-small
                  class="d-inline-block"
                >
                  <b-button
                    @click="clearAll"
                    :disabled="clearingAll"
                    v-if="activeName !== 'second'"
                    class="users-table__header__content--option"
                    size="sm"
                    >Clear all</b-button
                  >
                </b-overlay>
                <b-button
                  id="show-btn"
                  @click="$refs.newUser.showModal('Add new')"
                  variant="info"
                  class="users-table__header__content--add-user-option"
                  size="sm"
                  ><i class="fa fa-user-plus"></i> Add user</b-button
                >
                <NewUser
                  class="users-table__header__content"
                  :activeName="activeName"
                  ref="newUser"
                  @getUsers="getUsers"
                  @activeEditSpinner="activeEditSpinner"
                />
              </div>
            </b-col>
          </b-row>
        </b-th>
      </b-tr>
    </template>
    <template #cell(queue)="data">
      {{ data.item.quote_resume.queue }}
    </template>

    <template #cell(failed)="data">
      {{ data.item.quote_resume.failed }}
    </template>
    <template #cell(process)="data">
      {{ data.item.quote_resume.process }}
    </template>
    <template #cell(sent)="data">
      {{ data.item.quote_resume.sent }}
    </template>

    <template #cell(is_busy)="data">
      <b-spinner
        small
        v-if="statusSpinner.index === data.index"
        variant="info"
        label="Spinning"
      ></b-spinner>
      <span
        v-else
        @click="changeStatus(data.item, data.index)"
        v-tooltip.bottom="'Change status'"
      >
        <b-icon
          icon="clock-fill"
          v-if="data.item.is_busy"
          class="users-table__content__actions--busy"
        ></b-icon>
        <b-icon
          icon="check-circle-fill"
          v-else
          class="users-table__content__actions--active"
        ></b-icon>
      </span>
    </template>

    <template #cell(quotes)="data">
      <div class="users-table__content__options">
        <b-form-input
          :key="data.item.id"
          v-model="numberOfQuotes[data.index]"
          placeholder="Quotes"
          type="number"
          size="sm"
          class="users-table__content__options--assign-input"
          autocomplete="off"
          :disabled="!data.item.is_active"
        >
        </b-form-input>
        <b-overlay
          :show="assigning.index === data.index"
          rounded
          opacity="0.6"
          spinner-small
          class="d-inline-block"
          @hidden="onHiddenAssign(data.index)"
          :id="data.index"
        >
          <b-button
            :id="data.index"
            :ref="'button-assign' + data.index"
            :disabled="
              assigning[data.index] === data.index || !data.item.is_active
            "
            @click="assignQuotes(data.item, data.index)"
            class="users-table__content__options--assign-button"
            size="sm"
            >Assign</b-button
          >
        </b-overlay>
        <b-overlay
          :show="clearing.index === data.index"
          rounded
          opacity="0.6"
          spinner-small
          class="d-inline-block"
          @hidden="onHiddenClear(data.index)"
          :id="data.index"
        >
          <b-button
            :id="data.index"
            :ref="'button-clear' + data.index"
            :disabled="clearing[data.index] || !data.item.is_active"
            @click="clearQuotes(data.item, data.index)"
            class="users-table__content__options--clear-button"
            size="sm"
          >
            Clear
          </b-button>
        </b-overlay>
      </div>
    </template>
    <template #cell(actions)="data">
      <div class="users-table__content__actions">
        <b-spinner
          small
          v-if="enableSpinner.index === data.index"
          variant="info"
          label="Spinning"
        ></b-spinner>
        <InputSwitch
          v-else
          v-show="activeName !== 'second'"
          v-model="data.item.is_active"
          name="active-switch"
          @click="enableDisable(data.item, data.index)"
          v-tooltip.bottom="'Enable / disable user'"
        />
        <b-spinner
          small
          v-if="editUserSpinner.index === data.index"
          variant="info"
          label="Spinning"
        ></b-spinner>
        <span
          v-else
          @click="$refs.newUser.showModal('Edit', data.item, data.index)"
          v-tooltip.bottom="'Edit user'"
        >
          <i class="pi pi-pencil users-table__content__actions--edit-user"></i>
        </span>
        <b-spinner
          small
          v-if="deleteSpinner.index === data.index"
          variant="info"
          label="Spinning"
        ></b-spinner>
        <span
          v-else
          @click="deleteUser(data.item, data.index)"
          v-tooltip.bottom="'Delete user'"
        >
          <i class="pi pi-trash users-table__content__actions--delete-user"></i>
        </span>
      </div>
    </template>
  </b-table>
</template>

<script>
import { warningMessage } from "@/api/errorMessages";
import {
  charlieUsersTableField,
  uploaderUsersTableField
} from "@/utils/usersTable.js";
import NewUser from "./NewUser.vue";

export default {
  name: "UsersTable",
  components: {
    NewUser
  },
  props: {
    users: Array,
    totalUnassigned: Number,
    activeName: String
  },
  data() {
    return {
      fields: null,
      sortDirection: "asc",
      sortBy: "is_busy",
      sortDesc: false,
      numberOfQuotes: [],
      generalNumberOfQuotes: null,
      distributing: false,
      clearing: { index: null },
      clearingAll: false,
      assigning: { index: null },
      statusKey: 0,
      enableSpinner: { index: null },
      deleteSpinner: { index: null },
      statusSpinner: { index: null },
      editUserSpinner: { index: null }
    };
  },
  created() {
    if (this.activeName === "first") {
      this.fields = [...charlieUsersTableField];
    } else {
      this.fields = [...uploaderUsersTableField];
    }
  },
  methods: {
    async distributeQuotes() {
      this.distributing = true;
      let info = {};
      info.departmentId = this.$store.getters[
        "login/showUserLoggedIn"
      ][0].department.id;
      info.numberOfQuotes = this.generalNumberOfQuotes;
      let response = await this.$store.dispatch(
        "usersManagement/allocate/distributeQuotes",
        info
      );
      this.generalNumberOfQuotes = null;
      this.distributing = false;
      if (response?.status == 200) {
        this.$emit("getUsers");
      }
    },
    async clearAll() {
      let departmentId = this.$store.getters["login/showUserLoggedIn"][0]
        .department.id;
      this.clearingAll = true;
      let response = await this.$store.dispatch(
        "usersManagement/allocate/clearQuotes",
        departmentId
      );
      this.generalNumberOfQuotes = null;
      this.clearingAll = false;
      if (response?.status == 200) {
        this.$emit("getUsers");
      }
    },
    onHiddenAssign(index) {
      this.$refs["button-assign" + index].focus();
    },
    onHiddenClear(index) {
      this.$refs["button-clear" + index].focus();
    },
    async assignQuotes(user, index) {
      this.assigning.index = index;
      if (
        this.numberOfQuotes[index] == null ||
        this.numberOfQuotes[index] == ""
      ) {
        this.swal({
          title: "Warning!",
          text: "The number of quotes is required.",
          icon: "warning",
          button: "OK"
        });
        this.assigning.index = null;
      } else {
        let info = {};
        info.departmentId = this.$store.getters[
          "login/showUserLoggedIn"
        ][0].department.id;
        info.payload = {};
        info.payload.limit = this.numberOfQuotes[index];
        info.payload.user_id = user.id;
        let response = await this.$store.dispatch(
          "usersManagement/userConfig/assignQuotes",
          info
        );
        this.assigning.index = null;
        if (response?.status == 200) {
          this.numberOfQuotes[index] = null;
          this.statusKey += 1;
          this.$emit("input", this.statusKey);
        }
      }
    },
    async clearQuotes(user, index) {
      this.clearing.index = index;
      let info = {};
      if (
        this.numberOfQuotes[index] == null ||
        this.numberOfQuotes[index] == ""
      ) {
        info.limit = 0;
      } else {
        info.limit = this.numberOfQuotes[index];
      }
      info.userId = user.id;
      info.departmentId = this.$store.getters[
        "login/showUserLoggedIn"
      ][0].department.id;
      let response = await this.$store.dispatch(
        "usersManagement/userConfig/clearQuotes",
        info
      );
      if (response?.status == 200) {
        this.numberOfQuotes[index] = null;
        this.statusKey += 1;
        this.$emit("input", this.statusKey);
      }
      this.clearing.index = null;
    },
    async deleteUser(user, index) {
      this.deleteSpinner.index = index;
      const acceptChanges = await warningMessage(
        "You won't be able to revert this!"
      );
      if (acceptChanges) {
        let response = await this.$store.dispatch(
          "usersManagement/deleteUser",
          user.id
        );
        this.deleteSpinner.index = null;
        if (response?.status === 204) {
          this.getUsers();
        }
      }
      this.deleteSpinner.index = null;
    },
    async changeStatus(user, index) {
      this.statusSpinner.index = index;
      let info = {};
      info.userId = user.id;
      info.departmentId = this.$store.getters[
        "login/showUserLoggedIn"
      ][0].department.id;
      info.rolId = user.rol_id;
      info.isBusy = {};
      info.isBusy.is_busy = !user.is_busy;
      let response = await this.$store.dispatch(
        "usersManagement/userConfig/changeStatus",
        info
      );
      this.statusSpinner.index = null;
      if (response?.status == 200) {
        this.statusKey += 1;
        this.$emit("input", this.statusKey);
      }
    },
    async enableDisable(user, index) {
      this.enableSpinner.index = index;
      let info = {};
      info.userId = user.id;
      info.departmentId = this.$store.getters[
        "login/showUserLoggedIn"
      ][0].department.id;
      info.rolId = user.rol_id;
      info.isBusy = {};
      info.isBusy.is_active = !user.is_active;
      info.isBusy.is_busy = user.is_active;
      let response = await this.$store.dispatch(
        "usersManagement/userConfig/changeStatus",
        info
      );
      this.enableSpinner.index = null;
      if (response?.status == 200) {
        this.statusKey += 1;
        this.$emit("input", this.statusKey);
      }
    },
    getUsers() {
      this.$emit("getUsers");
    },
    activeEditSpinner(value) {
      this.editUserSpinner.index = value;
    }
  }
};
</script>

<style lang="scss" scoped>
%z-index--buttons {
  z-index: 100;
  display: flex;
  position: relative;
  flex-flow: row-reverse wrap;
  top: 180px;
  margin-right: $margin-most-used;
}

.users-table {
  font-size: 12px;
  @include box-shadow;
  &__header {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    flex-wrap: wrap;
    &__tittle {
      color: rgb(241, 241, 241);
      margin: auto 0;
    }
    &__content {
      @include flex-wrap(flex-end);

      &--option {
        @include primary-button;
        margin: 5px;
      }

      &--add-user-option {
        margin: 5px;
        @include secondary-button;
      }

      &--input {
        margin: 5px;
        width: 200px;
      }
    }
  }
  &__content {
    &__actions {
      @include flex-wrap(space-around);
      &--active {
        color: $color-user-active;
        margin-right: 0.8rem;
        font-size: 16px;
        cursor: pointer;
      }
      &--busy {
        color: $color-user-busy;
        margin-right: 0.8rem;
        font-size: 16px;
        cursor: pointer;
      }
      &--edit-user {
        color: #17a2b8;
        font-size: 16px;
        cursor: pointer;
      }
      &--delete-user {
        color: $color-user-busy;
        font-size: 16px;
        cursor: pointer;
      }
    }

    &__options {
      @include flex-wrap(space-between);
      &--assign-input {
        width: 50%;
        padding: 0.25rem;
        font-size: 0.6rem;
      }
      &--assign-button {
        @include secondary-button;
        padding: 0.25rem;
        font-size: 0.6rem;
      }
      &--clear-button {
        @include primary-button;
        padding: 0.25rem;
        font-size: 0.6rem;
      }
    }
  }
}
::v-deep .p-inputswitch-slider {
  transform: scale(0.6);
}
::v-deep .b-table {
  border-radius: 6px;
}
::v-deep th {
  border-radius: 0 !important;
}
::v-deep .table .thead-light th {
  border-radius: 0;
  padding: 20px 10px;
}
</style>
